import { render, staticRenderFns } from "./ProfilePostEdit.vue?vue&type=template&id=5472a73b&scoped=true&"
import script from "./ProfilePostEdit.vue?vue&type=script&lang=js&"
export * from "./ProfilePostEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePostEdit.vue?vue&type=style&index=0&id=5472a73b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5472a73b",
  null
  
)

export default component.exports